module.exports = __webpack_public_path__ + "static/media/地震後曾去哪些地方暫住.fb996bba.png";